import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: 'AIzaSyBKhmKKmePnq-qcPvBe9-SyD5i_pQ-4ers',
  authDomain: 'sellhub-8c0a2.firebaseapp.com',
  projectId: 'sellhub-8c0a2',
  storageBucket: 'sellhub-8c0a2.firebasestorage.app',
  messagingSenderId: '388672727031',
  appId: '1:388672727031:web:49c2f87d9d41bb89deb0f2',
  measurementId: 'G-PEG4TEGP29'
}

const app = initializeApp(firebaseConfig)
let analytics = null

if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

export { app, analytics }
